// extracted by mini-css-extract-plugin
export default {"logoContainer":"headerLogo_logoContainer__-0RrW"};